export function getRequiredApiBaseUrl(): string {
  const value = (process.env.NEXT_PUBLIC_API_BASE_URL ?? '').trim().replace(/\/$/, '');

  if (!value) {
    throw new Error('NEXT_PUBLIC_API_BASE_URL is required');
  }

  return value;
}

export function buildApiUrl(path: string): string {
  return path.startsWith('http') ? path : `${getRequiredApiBaseUrl()}${path}`;
}